const topColum = (() => {
  if (document.querySelector("body#pageTop") !== null) {



    let hash = location.hash
    // console.log('hash:' + hash);

    let sec = document.querySelector('#jsSecColum');
    let outer = sec.querySelectorAll('.js-colum-outer');

    let btnWrap = sec.querySelector('.js-btn-wrap');
    let btnBox = btnWrap.querySelector('.js-btn-box');
    let outer0508 = sec.querySelector('.js-colum-outer-0508');
    let inner0508 = outer0508.querySelector('.js-colum-inner-0508');


    if (
      hash == '#column05' ||
      hash == '#column06' ||
      hash == '#column07' ||
      hash == '#column08' ||
      hash == '#column09' ||
      hash == '#column10' ||
      hash == '#column11' ||
      hash == '#column12' ||
      hash == '#column13' ||
      hash == '#column14' ||
      hash == '#column15' ||
      hash == '#column16'
    ) {
      btnBox.classList.add('is-act');
      outer0508.classList.remove('is-close');
    } else {
      outer0508.classList.add('is-close');
    }


    outer.forEach((element, index) => {

      let ttl = element.querySelector('.js-ttl-wrap');
      let colum = element.querySelector('.js-colum-wrap');
      let columInner = element.querySelector('.js-colum-wrap-inner');
      let close = element.querySelector('.js-close-box');

      let columInnerH = columInner.clientHeight;


      ttl.addEventListener('click', () => {
        columInnerH = columInner.clientHeight;

        if (ttl.classList.contains('is-act') == true) {
          ttl.classList.remove('is-act');
          colum.classList.remove('is-act');
          colum.style.height = `${0}px`

        } else {
          ttl.classList.add('is-act');
          colum.classList.add('is-act');
          colum.style.height = `${columInnerH + 4}px`
        }
      });

      close.addEventListener('click', () => {
        ttl.classList.remove('is-act');
        colum.classList.remove('is-act');
        colum.style.height = `${0}px`
      });

      // ttl.classList.add('is-act'); //
      // colum.classList.add('is-act'); //
      // colum.style.height = `${columInnerH + 4}px` //



      setTimeout(() => {
        columInnerH = columInner.clientHeight;
        let num = String(index + 1).padStart(2, '0')
        console.log(num);
        if (hash == `#column${num}`) {
          ttl.classList.add('is-act');
          colum.classList.add('is-act');
          colum.style.height = `${columInnerH + 4}px`
        }
      }, 100);

    });



    btnBox.addEventListener('click', () => {
      if (btnBox.classList.contains('is-act') == true) {
        btnBox.classList.remove('is-act');
        outer0508.classList.add('is-close');
      } else {
        btnBox.classList.add('is-act');
        outer0508.classList.remove('is-close');
      }
    });
    // btnBox.classList.add('is-act'); //
    // outer0508.classList.remove('is-close'); //






  }
})()
export default topColum;